<template>
  <v-container style="max-width: 1800px">
    <v-card class="ma-4">
      <v-row>
        <modal-devices
          :showDialog="showDialog"
          :devices="devices"
          @close="showDialog = false"
          @addDevice="addDevice"
          section="products"
          :deviceTypes="[ 'inverter',
            'module',
            'stringbox',
            'accessory',
            'cable',
            'connector',
            'rail',
            'transformer',
            'generator'
          ]"
        >
        </modal-devices>
        <modal-devices
          :showDialog="showDialogServices"
          :devices="devices"
          @close="showDialogServices = false"
          @addDevice="addDevice"
          section="services"
          :deviceTypes="['service']"
        ></modal-devices>
      </v-row>
      <!-- Products -->

      <v-toolbar color="primary" dark> Materiais </v-toolbar>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn @click="showDialog = true" color="secondary" :disabled= "disabled"> +Novo</v-btn>
        </v-row>
        <br />

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Remover</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Quantidade</th>
                <th class="text-left"     v-if ="accessUnitPrice">Cost(Unit.)</th>
                <th class="text-left"      v-if  ="accessUnitPrice">Preço(Unit.)</th>
                <th class="text-left"      v-if  ="accessUnitPrice" >Custo Total</th>
                <th class="text-left"     v-if  ="accessUnitPrice">Preço Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in quote.products.items" :key="index">
                <td>
                  <v-btn :disabled= "disabled" @click="deleteProduct(index)">
                    <v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
                <td style="min-width: 300px; max-width: 300px">
                  {{ product.description }}
                </td>

                <td style="min-width: 100px; max-width: 150px">
                  <vuetify-money
              
                  :disabled= "disabled"
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="product.quantity"
                    v-bind:options="$globalFunctions.optionsInteger"
                  />
                </td>
                <td style="min-width: 150px; max-width: 160px"     v-if ="accessUnitPrice">
                  <vuetify-money
                  
                  :disabled= "disabled"
                     @change.native="updatePrice(quote.discount, null)"
                    v-model.number="product.cost"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </td>
                <td style="min-width: 150px; max-width: 160px"      v-if ="accessUnitPrice">
                  <vuetify-money
                 
                    :disabled= "disabled"
                    
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="product.price"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </td>

                <td    v-if ="accessUnitPrice" ><span v-money-format="product.costTotal"></span></td>
                <td    v-if ="accessUnitPrice" ><span v-money-format="product.priceTotal"></span></td>
              </tr>
              <tr>
                <td v-if ="accessUnitPrice"></td>
                <td style="font-weight: bolder">Total</td>
                <td v-if ="accessUnitPrice"></td>
                <td v-if ="accessUnitPrice"></td>
                <td v-if ="accessUnitPrice"></td>
                <td style="font-weight: bolder">
                  <span v-money-format="quote.products.cost"></span>
                </td>
                <td style="font-weight: bolder">
                  <span v-money-format="quote.products.price"></span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <hr />
      </v-card-text>
    </v-card>

    <!-- Services -->
    <v-card class="ma-4">
      <v-toolbar color="primary" dark> Serviços </v-toolbar>
      <v-card-text>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn @click="showDialogServices = true" color="secondary" :disabled= "disabled">
            +Novo</v-btn
          >
        </v-row>
        <br />

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Remover</th>
                <th class="text-left">Descrição</th>
                <th class="text-left">Quantidade</th>
                <th class="text-left" v-if ="accessUnitPrice">Custo(Unit.)</th>
                <th class="text-left" v-if ="accessUnitPrice">Preço(Unit.)</th>
                <th class="text-left" v-if ="accessUnitPrice">Custo total</th>
                <th class="text-left" v-if ="accessUnitPrice">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(service, indexService) in quote.services.items"
                :key="indexService"
              >
                <td>
                  <v-btn :disabled= "disabled" @click="deleteService(indexService)">
                    <v-icon>mdi-delete</v-icon></v-btn
                  >
                </td>
                <td style="min-width: 300px; max-width: 300px">
                  {{ service.description }}
                </td>

                <td style="min-width: 100px; max-width: 150px">
                  <vuetify-money
                  :disabled= "disabled"
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="service.quantity"
                    v-bind:options="$globalFunctions.optionsInteger"
                  />
                </td>
                <td v-if ="accessUnitPrice" style="min-width: 150px; max-width: 160px">
                  <vuetify-money
                  :disabled= "disabled"
                      @change.native="updatePrice(quote.discount, null)"
                    v-model.number="service.cost"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </td>

                <td v-if ="accessUnitPrice" style="min-width: 150px; max-width: 160px">
                  <vuetify-money
                  :disabled= "disabled"
                   
                      @change.native="updatePrice(quote.discount, null)"
                    v-model.number="service.price"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </td>
                <td v-if ="accessUnitPrice"><span v-money-format="service.costTotal"></span></td>
                <td v-if ="accessUnitPrice"><span v-money-format="service.priceTotal"></span></td>
              </tr>

              <tr>
                <td v-if ="accessUnitPrice"></td>
                <td style="font-weight: bolder">Total</td>
                <td v-if ="accessUnitPrice"></td>
                <td v-if ="accessUnitPrice"></td>
                <td v-if ="accessUnitPrice"></td>
                <td style="font-weight: bolder">
                  <span v-money-format="quote.services.cost"></span>
                </td>
                <td style="font-weight: bolder">
                  <span v-money-format="quote.services.price"></span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <v-card class="ma-4">
      <v-toolbar color="secondary" dark> Totais </v-toolbar>
      <v-row class="mx-4">
        <v-col md="3" sm="12">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <vuetify-money
                    disabled
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="quote.cost"
                    label="SubTotal"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>
        <v-col md="3" sm="12">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <vuetify-money
                    disabled
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="quote.priceTarget"
                    label="Preço desejado"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col md="3" sm="12">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                  <vuetify-money
                  :disabled= "(disabled || !accessDiscount)"
                   
                    @change.native="updatePrice(quote.discount, null)"
                    v-model.number="quote.discount"
                    label="Desconto"
                    v-bind:options="$globalFunctions.optionsPercent"
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col md="3" sm="12">
          <v-card>
            <v-list-item three-line>
              <v-list-item-content>
                <!-- <div class="overline mb-4">
                          Comissão
                        </div> -->
                <v-list-item-title class="headline mb-1" style="color: blue">
                  <!-- <span v-money-format="quote.price"></span> -->
                  <vuetify-money
                  :disabled= "(disabled || !accessDiscount)"
                    @change.native="updatePrice(null, quote.price)"
                    v-model.number="quote.price"
                    label="Preço final"
                    v-bind:options="$globalFunctions.optionsMoneyBr"
                  />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card>

   
        </v-col>
      </v-row>
    </v-card>
    <v-card class="ma-4 mt-8">
      <v-toolbar color="grey lighten-1" dark> Observações </v-toolbar>
        <v-row class="ma-2">
          <v-textarea v-model = "quote.comment"   :disabled= "disabled"></v-textarea>
        </v-row>
    </v-card>
    
  </v-container>
</template>

<script>
import finance from "@/libraries/functions/finance.js";
import ModalDevices from "../modals/ModalDevices.vue";
import hebelApi from "../../../../libraries/hebel/hebelApi"


export default {
  name: "quote-card",
  props: ["quote", "enterprise", "solarPlant", "site","disabled","accessUnitPrice", "accessDiscount"],
  components: {
    ModalDevices,
  },
  data() {
    return {
      showDialog: false,
      showDialogServices: false,
      showFinance: false,
      devices: [],
      fields: [
        { key: "code", label: "Código" },
        { key: "description", label: "Descrição" },
        { key: "price", label: "Preço Unit." },
        { key: "quantity", label: "Quantidade" },
        // { key: "Product.MeasurementUnit", label: "Unidade" },
        { key: "priceTotal", label: "Total" }, //MeasurementUnit
      ],
    };
  },
  async mounted() {
    //this.devices = await this.$dao.getDevices(window.eid, "*", "*", true);
    this.devices = await hebelApi.devices.getAll("*","*",true);
    this.devices.sort(function (a, b) {
      return a.acPower - b.acPower;
    });
    this.devices.sort(function (a, b) {
      return a.dcPower - b.dcPower;
    });

    this.devices.sort(function (a, b) {
      return a.power - b.power;
    });
    this.devices.sort(function (a, b) {
      var nameA = a.manufacturer.toUpperCase(); // ignore upper and lowercase
      var nameB = b.manufacturer.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    });

    this.devices.sort(function (a, b) {
      var nameA = a.deviceType.toUpperCase(); // ignore upper and lowercase
      var nameB = b.deviceType.toUpperCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
    });
  },
  methods: {
    addDevice(device, section) {
      var d = device;
      var p = device.product;

      var product = {
        deviceId: d.id,
        code: d.code,
        description: d.description,
        cost: p.cost,
        price: p.price,
        unit: d.unit,
        quantity: 1,
        costTotal: p.cost * d.quantity,
        priceTotal: p.price * d.quantity,
        manufacturer: d.manufacturer,
        deviceType: d.deviceType,
      };
      //Put this formula inside
      // this.quote[section].items.push({
      //        deviceId: d.id,
      //     code: d.code,
      //     description: d.description,
      //     cost: d.cost,
      //     price: d.price,
      //     unit: d.unit,
      //     quantity: 1,
      //     costTotal: d.product.cost * d.product.quantity,
      //     priceTotal: d.product.price * d.product.quantity,
      //     manufacturer: d.manufacturer,
      // });

      this.quote.addProduct(this.enterprise, product, section);
      //this.quote.updatePrice(this.enterprise);

      this.showDialog = false;
      this.showDialogServices = false;
    },
    addProduct(index) {
      console.log("addProduct");
      var d = Object.assign({}, this.devices[index]);

      this.quote.products.items.push({
        deviceId: d.id,
        code: d.code,
        description: d.description,
        cost: d.cost,
        price: d.price,
        unit: d.unit,
        quantity: 1,
        costTotal: d.product.cost * d.product.quantity,
        priceTotal: d.product.price * d.product.quantity,
        manufacturer: d.manufacturer,
      });
      this.showDialog = false;
    },
    deleteProduct(index) {
      console.log("deleteProduct>" + index);
      this.quote.products.items.splice(index, 1);
      this.updatePrice();
    },

    deleteService(index) {
      console.log("deleteProduct>" + index);
      this.quote.services.items.splice(index, 1);
      this.updatePrice();
    },
    updatePrice(discount, price) {
      //alert("updatePrice");
      // var price = 0;
      // var cost = 0;

      // for (var p = 0; p < this.quote.products.items.length; p++) {
      //   this.quote.products.items[p].priceTotal =
      //     this.quote.products.items[p].quantity * this.quote.products.items[p].price;
      //   this.quote.products.items[p].costTotal =
      //     this.quote.products.items[p].quantity * this.quote.products.items[p].cost;
      //   price += this.quote.products.items[p].priceTotal;
      //   cost += this.quote.products.items[p].costTotal;
      // }
      // this.quote.price = price;
      // this.quote.cost = cost;
      this.quote.updatePrice(this.enterprise, discount, price);

      this.quote.formCashFlow.investmentCost = this.quote.price;
    },
    test() {
      alert("test");
    },
    getGetCashFlow() {
      this.quote.cashFlow = finance.investmentCashFlow2(
        this.quote.formCashFlow.investmentCost,
        this.quote.formCashFlow.upFrontInvesment,
        this.quote.formCashFlow.numberOfPayments,
        this.quote.formCashFlow.loanInterestRate,
        this.quote.formCashFlow.inflationRate,
        this.solarPlant.production.years,
        this.site.electricalProps.averageBilling.price,
        this.site.electricalProps.averageBilling.quantity * 12,
        this.site.electricalProps.averageBilling.minAmount * 12,
        this.solarPlant.modules[0].performanceOverYears

        // this.quote.formCashFlow.monthlySavings
      );
      this.showFinance = true;
    },

    formatReais(value) {
      return new Intl.NumberFormat("pt-BR", {
        currency: "BRL",
        style: "currency",
        minimumFractionDigits: 2,
      }).format(value || 0);
    },
  },
};
</script>


<style scoped>
</style>